import { RETRYABLE_PATTERNS } from '@/modules/webrtc/agora/const';

export default {
  isNetworkError(error) {
    const code = (error && error.code) ? String(error.code) : '';
    const message = (error && error.message) ? String(error.message) : '';
    return RETRYABLE_PATTERNS.test(code) || RETRYABLE_PATTERNS.test(message);
  }
}
